import * as React from 'react';

import { find } from 'lodash';
import { Query } from 'react-apollo';

import ToastActions from 'actions/ToastActions';
import CurrentUser from 'auth/CurrentUser';
// @ts-ignore
import ChatLearnMore from 'chat/components/ChatLearnMore';
// @ts-ignore
import ChatStore from 'chat/stores/ChatStore';
// @ts-ignore
import { promiseGroupOrRootChats } from 'chat/utils/ChatPromises';
import Group from 'entities/Group';
// @ts-ignore
import { rootGroup, rootGroupCode } from 'entities/RootGroup';
import { loadGQLUserGroupByCode } from 'groups/lib/GroupPromises';
import { LocationDescriptor, RouterState } from 'lib/ReactRouterTypes';
import RemindAPI from 'lib/RemindAPI';

import { CanSendAnnouncementToOrg } from 'app/queries/__generated__/CanSendAnnouncementToOrg';

import CAN_SEND_ANNOUNCEMENT_TO_ORG from 'app/queries/CanSendAnnouncementToOrg.gql';

class ChatDefaultView extends React.Component<{ params: { groupCode: string } }> {
  // This code controls which chat thread is focused upon entering the /messages or /inbox routes
  // on enter is used for react-router (3.x, deprecated in 4.x) see https://github.com/ReactTraining/react-router/blob/v3/docs/API.md#onenternextstate-replace-callback
  /* eslint-disable @remind/remind/no-on-functions */
  static async onEnter(
    nextState: RouterState & { params: { groupCode: string } },
    replaceWith: (location: LocationDescriptor) => void,
    callback: Function
  ) {
    const { query } = nextState.location;
    const { groupCode } = nextState.params;

    const redirectToFirstChat = async (group: Group, groupCode: string) => {
      await promiseGroupOrRootChats(groupCode);
      const chats = ChatStore.getChats({ id: group.getId(), className: group.getName() });
      const firstChat = chats.find((chat: any) => !chat.isNew());
      if (firstChat) {
        replaceWith({ pathname: `/classes/${groupCode}/messages/${firstChat.id}`, query });
      }
      callback();
    };

    if (groupCode === rootGroupCode) {
      redirectToFirstChat((rootGroup as any) as Group, groupCode);
      return;
    }

    const gqlGroup = await loadGQLUserGroupByCode(groupCode);
    const group: Group = new Group(gqlGroup);
    const user = CurrentUser.getUser();

    if (!gqlGroup || !group || !user) {
      callback();
      return;
    }

    const isStaffClass = group.isStaffClass();
    const staffClassOrgId = group.getStaffClassOrgId();

    if (isStaffClass && staffClassOrgId) {
      // if the group is a school or district and the user has canSendAnnouncement permission, redirect to /stream
      const canSendAnnouncementToOrg = await RemindAPI.execute<CanSendAnnouncementToOrg>({
        query: CAN_SEND_ANNOUNCEMENT_TO_ORG,
        variables: { orgId: staffClassOrgId },
      }).then(
        res => {
          const org = res.organizations[0];
          return org && org.permissions.canSendAnnouncement;
        },
        err => {
          console.error('ChatDefaultView - canSendAnnouncementToOrg query failure');
          console.warn(err);
          return false;
        }
      );

      if (canSendAnnouncementToOrg) {
        replaceWith({
          pathname: `/classes/${groupCode}/messages/stream`,
          query,
        });
        callback();
        return;
      } else {
        redirectToFirstChat(group, groupCode).catch(err => {
          ToastActions.showErrorToast(
            'Messages could not be loaded. Please wait and try again later.'
          );
          console.warn(err, err && err.stack);
          console.error('ChatDefaultView - error loading chats for org');
          callback();
        });
        return;
      }
    }

    const currentUserId = CurrentUser.getUserId();
    if (find(gqlGroup.owners, owner => owner.user.id == currentUserId)) {
      replaceWith({
        pathname: `/classes/${groupCode}/messages/stream`,
        query,
      });
      callback();
      return;
    }

    redirectToFirstChat(group, groupCode).catch(err => {
      ToastActions.showErrorToast('Messages could not be loaded. Please wait and try again later.');
      console.warn(err, err && err.stack);
      console.error('ChatDefaultView - error loading chats for group');
      callback();
    });
  }

  render() {
    return <ChatLearnMore groupCode={this.props.params.groupCode} />;
  }
}
export default ChatDefaultView;
